<template>
  <div :class="[$style.resource, theme && $style[theme]]" @click="$emit('click')">
    <b-avatar
      v-show="!hideAvatar"
      :name="resource.name"
      :url="avatar"
      :size="size"
    />

    <slot>
      <div :class="$style.text">
        <span v-if="headline" :class="$style.headline">{{ $t('staffer') }}</span>
        {{ resource.name || label }}
      </div>
    </slot>
    <slot name="additional" />
  </div>
</template>

<script>
const SIZE = {
  'default': '36px',
  'size-xs': '32px',
}

export default {

  emits: [
    'click',
  ],
  props: {

    avatar: {
      type: String,
      default: '',
    },

    resource: {
      type: Object,
      default: () => ({}),
    },

    theme: {
      type: String,
      required: false,
    },

    label: {
      type: String,
      default: '',
    },

    headline: {
      type: Boolean,
      default: false,
    },

    hideAvatar: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    size () {
      return this.theme ? SIZE[this.theme] : SIZE['default']
    },
  },
}
</script>

<style lang="scss" module>
@import '@/assets/stylesheets/typography';

.resource {
  display: flex;
  align-items: center;
  padding: 1rem 0;
}

.text {
  line-height: 1.5rem;
  flex: 1;
  max-width: calc(100% - 36px);
  padding-left: 12px;
  text-transform: capitalize;
}

.size-xs {
  padding: 0;

  .text {
    font-size: 14px;
    max-width: 194px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-self: center;
  }
}

.headline {
  display: block;
  font-size: 10px;
  line-height: 1.2em;
  color: $color-gray-08;
  text-transform: uppercase;
  padding-top: 3px;
  margin-bottom: -3px;
}
</style>
